export const checkForURL = (value: string) => value.match(
  /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,100}(\/\S*)?)/g,
);
